import { useEffect } from 'react';
import CommunitySection from '@/components/CommunitySection';

export default function CommunityPage() {
  useEffect(() => {
    document.title = 'COMMUNITY — ARC TOONS';
  }, []);

  return <CommunitySection />;
}
